import { render, staticRenderFns } from "./ppbkl.vue?vue&type=template&id=d20b277a"
import script from "./ppbkl.vue?vue&type=script&lang=js"
export * from "./ppbkl.vue?vue&type=script&lang=js"
import style0 from "./ppbkl.vue?vue&type=style&index=0&id=d20b277a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports